"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[435],{

/***/ 45343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bz": function() { return /* binding */ LoginType; },
/* harmony export */   "LC": function() { return /* binding */ PackingAction; },
/* harmony export */   "Pf": function() { return /* binding */ PackingState; },
/* harmony export */   "WA": function() { return /* binding */ TransportMode; }
/* harmony export */ });
/* unused harmony export PackingListDetails */

var LoginType;
(function(LoginType) {
    LoginType[/** Agents */ "AGENTE"] = "AGENTE";
    LoginType[/** AS400 User */ "AS400"] = "AS400";
    LoginType[/** Clients */ "CLIENTE"] = "CLIENTE";
    LoginType[/** Employee */ "EMPLEADO"] = "EMPLEADO";
    LoginType[/** Intranet */ "INTRANET"] = "INTRANET";
    LoginType[/** AS400 */ "LOGIN_400"] = "LOGIN_400";
    LoginType[/** Mayoral Workshops */ "TALLER"] = "TALLER";
    LoginType[/** Boston Workshops */ "TALLERB"] = "TALLERB";
    LoginType["TALLERB_R"] = "TALLERB_R";
    LoginType[/** Missa Workshops */ "TALLERM"] = "TALLERM";
    LoginType["TALLERM_R"] = "TALLERM_R";
    LoginType["TALLER_R"] = "TALLER_R";
    LoginType[/** Mayoral Shops */ "TIENDA"] = "TIENDA";
    LoginType[/** Boston Shops */ "TIENDAB"] = "TIENDAB";
    LoginType[/** Mayoral Online */ "USER_ON"] = "USER_ON";
    LoginType[/** WSC */ "WSC"] = "WSC";
})(LoginType || (LoginType = {}));
var PackingAction;
(function(PackingAction) {
    PackingAction["ADD"] = "ADD";
    PackingAction["DELETE"] = "DELETE";
    PackingAction["UPDATE"] = "UPDATE";
})(PackingAction || (PackingAction = {}));
var PackingListDetails;
(function(PackingListDetails) {
    PackingListDetails["HIDE"] = "HIDE";
    PackingListDetails["SHOW"] = "SHOW";
})(PackingListDetails || (PackingListDetails = {}));
var PackingState;
(function(PackingState) {
    PackingState["CLOSED"] = "CLOSED";
    PackingState["IMPORTED"] = "IMPORTED";
    PackingState["OPEN"] = "OPEN";
})(PackingState || (PackingState = {}));
var TransportMode;
(function(TransportMode) {
    TransportMode["AIR"] = "AIR";
    TransportMode["ROAD"] = "ROAD";
    TransportMode["SEA"] = "SEA";
})(TransportMode || (TransportMode = {}));


/***/ }),

/***/ 44435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login_LoginView; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/ui/Brand/index.ts + 2 modules
var Brand = __webpack_require__(25314);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mayoral/ui/Dropdown/Dropdown.tsx
var Dropdown = __webpack_require__(21115);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(90584);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/login/LoginContext.tsx
var LoginContext = __webpack_require__(41577);
// EXTERNAL MODULE: ./src/lib/constants/index.ts + 5 modules
var constants = __webpack_require__(29136);
;// CONCATENATED MODULE: ./src/components/login/LoginLangDropdown/LoginLangDropdown.tsx
/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 







var LangDropdown = (0,styled/* default */.ZP)(Dropdown/* Dropdown */.L, {
    name: "LoginLangDropdown",
    slot: "Root"
})({
    fontSize: 14,
    height: 37,
    top: "3px"
});
var LoginLangDropdown = function() {
    var isManager = (0,react.useContext)(LoginContext/* default */.ZP).isManager;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var locale = router.locale, locales = router.locales;
    var options = locales.map(function(value) {
        return {
            label: t(value.toUpperCase()),
            value: value
        };
    });
    var handleChange = function(e) {
        var value = e.target.value;
        var path = isManager ? constants/* Routes.LOGIN_MANAGER */.Z5.LOGIN_MANAGER : constants/* Routes.LOGIN */.Z5.LOGIN;
        router.push(path, path, {
            locale: value
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LangDropdown, {
        value: locale,
        options: options,
        onChange: handleChange,
        MenuProps: {
            PaperProps: {
                style: {
                    maxHeight: 260
                }
            }
        }
    });
};
/* harmony default export */ var LoginLangDropdown_LoginLangDropdown = (LoginLangDropdown);

;// CONCATENATED MODULE: ./src/components/login/LoginLangDropdown/index.ts
/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/components/ui/HelperText/index.tsx + 1 modules
var HelperText = __webpack_require__(8547);
// EXTERNAL MODULE: ./src/components/ui/Notification/NotificationContext.tsx
var NotificationContext = __webpack_require__(10022);
// EXTERNAL MODULE: ./src/components/ui/Notification/notification.utils.ts
var notification_utils = __webpack_require__(65067);
// EXTERNAL MODULE: ./src/lib/graphql/cache.ts + 10 modules
var graphql_cache = __webpack_require__(53300);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
;// CONCATENATED MODULE: ./node_modules/@mayoral/sdk/core/auth/__generated__/login.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation Login($type: LoginType!, $username: String!, $password: String!) {\n    login(type: $type, username: $username, password: $password) {\n      token\n      refreshToken\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var defaultOptions = {};
var LoginDocument = (0,lib/* gql */.Ps)(_templateObject());
/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      type: // value for 'type'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */ function useLoginMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation/* useMutation */.D(LoginDocument, options);
}

;// CONCATENATED MODULE: ./node_modules/@mayoral/sdk/core/customer/__generated__/customer.ts


function customer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Customer {\n    customer {\n      username\n      firstName\n      lastName\n      email\n      loggedIn @client\n    }\n  }\n"
    ]);
    customer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var customer_defaultOptions = {};
var CustomerDocument = (0,lib/* gql */.Ps)(customer_templateObject());
/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */ function useCustomerQuery(baseOptions) {
    var options = _object_spread({}, customer_defaultOptions, baseOptions);
    return Apollo.useQuery(CustomerDocument, options);
}
function useCustomerLazyQuery(baseOptions) {
    var options = _object_spread({}, customer_defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CustomerDocument, options);
}

// EXTERNAL MODULE: ./src/lib/utils/cookies.ts + 1 modules
var cookies = __webpack_require__(15268);
;// CONCATENATED MODULE: ./src/lib/graphql/hooks/useLogin.ts
/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 




/**
 * Wrapper for auto-generated useLoginMutation to globally handle cache / storage when logging in.
 */ var useLogin = function() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return useLoginMutation((0,src_object_spread/* default */.Z)({
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: CustomerDocument
            }, 
        ],
        update: function(cache, param) {
            var data = param.data;
            var _login = data.login, token = _login.token, refreshToken = _login.refreshToken;
            (0,cookies/* writeToCookies */.kD)(constants/* StorageTokens.TOKEN */.Gr.TOKEN, token, {
                expires: constants/* AuthCookieExpiration */.JG
            });
            (0,cookies/* writeToCookies */.kD)(constants/* StorageTokens.REFRESH_TOKEN */.Gr.REFRESH_TOKEN, refreshToken, {
                expires: constants/* AuthCookieExpiration */.JG
            });
            (0,graphql_cache/* loggedInVar */.AL)(true);
        }
    }, opts));
};
/* harmony default export */ var hooks_useLogin = (useLogin);

// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@mayoral/ui/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(86440);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
// EXTERNAL MODULE: ./node_modules/@mui/material/internal/SwitchBase.js + 1 modules
var SwitchBase = __webpack_require__(21964);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/CheckBoxOutlineBlank.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckBoxOutlineBlank = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/CheckBox.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var CheckBox = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/IndeterminateCheckBox.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var IndeterminateCheckBox = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox'));
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/rootShouldForwardProp.js
var rootShouldForwardProp = __webpack_require__(14136);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Checkbox/checkboxClasses.js


function getCheckboxUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCheckbox', slot);
}
const checkboxClasses = (0,generateUtilityClasses/* default */.Z)('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium']);
/* harmony default export */ var Checkbox_checkboxClasses = (checkboxClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js
'use client';



const _excluded = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"];















const useUtilityClasses = ownerState => {
  const {
    classes,
    indeterminate,
    color,
    size
  } = ownerState;
  const slots = {
    root: ['root', indeterminate && 'indeterminate', `color${(0,capitalize/* default */.Z)(color)}`, `size${(0,capitalize/* default */.Z)(size)}`]
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getCheckboxUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};
const CheckboxRoot = (0,styled/* default */.ZP)(SwitchBase/* default */.Z, {
  shouldForwardProp: prop => (0,rootShouldForwardProp/* default */.Z)(prop) || prop === 'classes',
  name: 'MuiCheckbox',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.indeterminate && styles.indeterminate, styles[`size${(0,capitalize/* default */.Z)(ownerState.size)}`], ownerState.color !== 'default' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${Checkbox_checkboxClasses.checked}, &.${Checkbox_checkboxClasses.indeterminate}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${Checkbox_checkboxClasses.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}));
const defaultCheckedIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBox, {});
const defaultIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBoxOutlineBlank, {});
const defaultIndeterminateIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(IndeterminateCheckBox, {});
const Checkbox = /*#__PURE__*/react.forwardRef(function Checkbox(inProps, ref) {
  var _icon$props$fontSize, _indeterminateIcon$pr;
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiCheckbox'
  });
  const {
      checkedIcon = defaultCheckedIcon,
      color = 'primary',
      icon: iconProp = defaultIcon,
      indeterminate = false,
      indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon,
      inputProps,
      size = 'medium',
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const icon = indeterminate ? indeterminateIconProp : iconProp;
  const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    indeterminate,
    size
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxRoot, (0,esm_extends/* default */.Z)({
    type: "checkbox",
    inputProps: (0,esm_extends/* default */.Z)({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/react.cloneElement(icon, {
      fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(indeterminateIcon, {
      fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
    }),
    ownerState: ownerState,
    ref: ref,
    className: (0,clsx/* default */.Z)(classes.root, className)
  }, other, {
    classes: classes
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mayoral/ui/Icon/Icon.tsx
var Icon = __webpack_require__(77166);
;// CONCATENATED MODULE: ./node_modules/@mayoral/ui/Checkbox/Checkbox.parts.tsx







var CheckboxBox = (0,styled/* default */.ZP)(Box/* default */.Z, {
    name: "Checkbox",
    slot: "Box",
    shouldForwardProp: function(prop) {
        return prop !== "checked" && prop !== "sx";
    },
    overridesResolver: function(props, styles) {
        return [
            styles.root,
            props.checked && styles.checked
        ];
    }
})(function(_param) {
    var theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme"
    ]);
    return (0,src_object_spread/* default */.Z)({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 16,
        height: 16,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.common.white,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme.palette.dark[200],
        "input:hover ~ &": {
            borderColor: theme.palette.dark[400]
        },
        "input:disabled ~ &": {
            color: theme.palette.dark[200],
            backgroundColor: theme.palette.dark[100],
            borderColor: theme.palette.dark[100]
        }
    }, props.checked && {
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        "input:hover ~ &": {
            backgroundColor: theme.palette.primary.dark,
            borderColor: "transparent"
        },
        "input:disabled ~ &": {
            color: theme.palette.dark[200],
            backgroundColor: theme.palette.dark[100],
            borderColor: "transparent"
        }
    });
});
var CheckedIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxBox, {
        checked: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
            name: "CheckXS",
            sx: {
                fontSize: 10,
                path: {
                    fill: "currentColor"
                }
            },
            viewBox: "0 0 8 8"
        })
    });
};
var NonCheckedIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxBox, {
        checked: false
    });
};
var IndeterminateIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxBox, {
        checked: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
            name: "MinusXS",
            sx: {
                fontSize: 10,
                path: {
                    fill: "currentColor"
                }
            },
            viewBox: "0 0 8 8"
        })
    });
};

;// CONCATENATED MODULE: ./node_modules/@mayoral/ui/Checkbox/Checkbox.tsx





var Checkbox_Checkbox_Checkbox = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox, (0,src_object_spread/* default */.Z)({
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(NonCheckedIcon, {}),
        checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedIcon, {}),
        indeterminateIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndeterminateIcon, {})
    }, props));
};

// EXTERNAL MODULE: ./node_modules/@mayoral/ui/Button/Button.tsx + 2 modules
var Button = __webpack_require__(93569);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/lib/utils/errors.ts
/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 
/**
 * Formats a client-side Apollo Error into a FormattedApolloError.
 */ var formatApolloError = function(error) {
    var ref, ref1, ref2;
    var graphQLErrors = error.graphQLErrors;
    var errors = [];
    if (graphQLErrors && graphQLErrors.length > 0) {
        var _errors;
        (_errors = errors).push.apply(_errors, (0,_to_consumable_array/* default */.Z)(graphQLErrors));
    }
    if (errors.length > 0) {
        var ref3 = errors[0], errorMessage = ref3.message, extensions = ref3.extensions;
        var requestId = extensions === null || extensions === void 0 ? void 0 : extensions.requestId;
        var code = extensions === null || extensions === void 0 ? void 0 : extensions.code;
        var message = extensions === null || extensions === void 0 ? void 0 : extensions.message;
        return {
            errorMessage: errorMessage,
            code: code,
            requestId: requestId,
            message: message
        };
    }
    return {
        errorMessage: error.message,
        code: (ref = error.extraInfo) === null || ref === void 0 ? void 0 : ref.code,
        requestId: (ref1 = error.extraInfo) === null || ref1 === void 0 ? void 0 : ref1.requestId,
        message: (ref2 = error.extraInfo) === null || ref2 === void 0 ? void 0 : ref2.message
    };
};

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/@types/global.ts
var global = __webpack_require__(45343);
;// CONCATENATED MODULE: ./src/components/login/LoginForm/login-form.utils.ts
/*
 Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 
var getLoginType = function(isManager) {
    if (isManager) {
        return global/* LoginType.TALLERB_R */.Bz.TALLERB_R;
    }
    return global/* LoginType.TALLERB */.Bz.TALLERB;
};
var getLoginDefaultValues = function(isManager) {
    var defaultLoginValues = {
        type: getLoginType(isManager),
        username: "",
        password: ""
    };
    if (false) {}
    return defaultLoginValues;
};

;// CONCATENATED MODULE: ./src/components/login/LoginForm/LoginForm.schema.ts
/*
 Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 

var loginSchema = function(isManager, t) {
    var ref = getLoginDefaultValues(isManager), password = ref.password, type = ref.type, username = ref.username;
    return es/* object */.Ry().shape({
        type: es/* string */.Z_().required().default(type),
        username: es/* string */.Z_().min(1, t("ERROR_NOMBRE_MINIMO_CARACTERES", {
            count: 1
        })).max(10, t("ERROR_NOMBRE_MAXIMO_CARACTERES", {
            count: 10
        })).required(t("ERROR_CAMPO_OBLIGATORIO")).default(username),
        password: es/* string */.Z_().required(t("ERROR_CAMPO_OBLIGATORIO")).default(password)
    });
};

;// CONCATENATED MODULE: ./src/components/login/LoginForm/LoginForm.tsx
/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 




















var LoginForm = function() {
    var ref, ref1;
    var isManager = (0,react.useContext)(LoginContext/* default */.ZP).isManager;
    var showNotification = (0,react.useContext)(NotificationContext/* NotificationAPIContext */.Ac).showNotification;
    var t = (0,esm/* useTranslation */.$G)().t;
    var schema = loginSchema(isManager, t);
    var ref2 = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        reValidateMode: "onChange",
        defaultValues: schema.getDefaultFromShape(),
        resolver: (0,yup/* yupResolver */.X)(schema)
    }), handleSubmit = ref2.handleSubmit, control = ref2.control, clearErrors = ref2.clearErrors, setError = ref2.setError, errors = ref2.formState.errors;
    var ref3 = (0,_sliced_to_array/* default */.Z)(hooks_useLogin({
        onError: function(e) {
            var formatedError = formatApolloError(e);
            setError("root.invalidCredentials", {
                type: "server",
                message: formatedError.errorMessage
            });
            showNotification({
                message: formatedError.errorMessage,
                type: notification_utils/* NotificationTypes.ERROR */.j_.ERROR,
                title: t("ERROR")
            });
        }
    }), 2), login = ref3[0], loading = ref3[1].loading;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                clearErrors("root.invalidCredentials");
                // FIXME: This should be provided by the REST service.
                (0,cookies/* writeToCookies */.kD)(constants/* StorageTokens.USERNAME */.Gr.USERNAME, data.username, {
                    expires: constants/* AuthCookieExpiration */.JG
                });
                (0,cookies/* writeToCookies */.kD)(constants/* StorageTokens.IS_MANAGER */.Gr.IS_MANAGER, isManager, {
                    expires: constants/* AuthCookieExpiration */.JG
                });
                (0,cookies/* writeToCookies */.kD)(constants/* StorageTokens.SELECTED_WORKSHOP */.Gr.SELECTED_WORKSHOP, +data.username);
                (0,graphql_cache/* usernameVar */.$7)(data.username);
                (0,graphql_cache/* isManagerVar */.st)(isManager);
                (0,graphql_cache/* workshopVar */.i2)(+data.username);
                login({
                    variables: (0,src_object_spread/* default */.Z)({}, data)
                });
                return [
                    2
                ];
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var usernameError = !!errors.username || !!((ref = errors.root) === null || ref === void 0 ? void 0 : ref.invalidCredentials);
    var passwordError = !!errors.password || !!((ref1 = errors.root) === null || ref1 === void 0 ? void 0 : ref1.invalidCredentials);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        direction: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            component: "form",
            id: "login-form",
            sx: {
                display: "flex",
                flexDirection: "column"
            },
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        typography: "h3",
                        fontWeight: 500,
                        mb: 0.75
                    },
                    children: t("INICIAR_SESION")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        typography: "body1",
                        color: "grey.700",
                        mb: 3
                    },
                    children: t("CREDENCIALES_ACCESO")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    control: control,
                    name: "username",
                    render: function(param) {
                        var _field = param.field, onChange = _field.onChange, value = _field.value;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* TextField */.n, {
                            onChange: onChange,
                            value: value,
                            error: usernameError,
                            required: true,
                            name: "username",
                            label: t("USUARIO"),
                            autoComplete: "username",
                            id: "username",
                            sx: {
                                mb: 1.5
                            },
                            variant: "outlined",
                            helperText: errors.username && /*#__PURE__*/ (0,jsx_runtime.jsx)(HelperText/* HelperText */.p, {
                                error: t(errors.username.message)
                            }),
                            disabled: loading
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                    control: control,
                    name: "password",
                    defaultValue: "",
                    render: function(param) {
                        var _field = param.field, onChange = _field.onChange, value = _field.value;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* TextField */.n, {
                            onChange: onChange,
                            value: value,
                            error: passwordError,
                            type: "password",
                            required: true,
                            name: "password",
                            label: t("CONTRASE\xd1A"),
                            autoComplete: "current-password",
                            id: "password",
                            variant: "outlined",
                            disabled: loading,
                            InputLabelProps: {
                                shrink: true
                            }
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox_Checkbox, {
                        disabled: loading
                    }),
                    label: "Recordar datos",
                    sx: {
                        mt: 0.5
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    type: "submit",
                    form: "login-form",
                    variant: "contained",
                    color: "primary",
                    size: "large",
                    loading: loading,
                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                        name: "ArrowRightS"
                    }),
                    sx: {
                        mt: 1.5
                    },
                    children: t("CONTINUAR")
                })
            ]
        })
    });
};
/* harmony default export */ var LoginForm_LoginForm = (LoginForm);

;// CONCATENATED MODULE: ./src/components/login/LoginForm/index.ts
/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 

// EXTERNAL MODULE: ./src/config/index.ts + 9 modules
var config = __webpack_require__(15565);
;// CONCATENATED MODULE: ./src/components/login/LoginView.tsx
/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 







var PageDefault = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 45498));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45498)
            ];
        }
    }
});
var LoginViewMenu = (0,styled/* default */.ZP)(Stack/* default */.Z, {
    name: "LoginView",
    slot: "Menu",
    shouldForwardProp: function(prop) {
        return prop !== "isMobile";
    }
})(function(param) {
    var theme = param.theme, isMobile = param.isMobile;
    return (0,src_object_spread/* default */.Z)({
        flexGrow: 0,
        flexBasis: 375,
        padding: theme.spacing(5),
        paddingBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.paper
    }, isMobile && {
        flexBasis: "100%"
    });
});
var LoginViewHead = (0,styled/* default */.ZP)(Grid/* default */.ZP, {
    name: "LoginView",
    slot: "Head"
})({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
});
var LoginView = function() {
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        flexGrow: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginViewMenu, {
                isMobile: isMobile,
                direction: "column",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginViewHead, {
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand/* Brand */.H, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginLangDropdown_LoginLangDropdown, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        direction: "column",
                        flexGrow: 1,
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm_LoginForm, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        alignSelf: "stretch",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    fontWeight: 500
                                },
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " MAYORAL MODA INFANTIL S.A.U."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    fontWeight: 500,
                                    color: "grey.600"
                                },
                                children: [
                                    "v",
                                    config/* default.public.version */.Z["public"].version
                                ]
                            })
                        ]
                    })
                ]
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageDefault, {})
        ]
    });
};
/* harmony default export */ var login_LoginView = (LoginView);


/***/ }),

/***/ 8547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ HelperText_HelperText; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mayoral/ui/Icon/Icon.tsx
var Icon = __webpack_require__(77166);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/theme/index.ts
var theme = __webpack_require__(33850);
;// CONCATENATED MODULE: ./src/components/ui/HelperText/HelperText.tsx
/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 






var HelperTextIcon = (0,styled/* default */.ZP)(Box/* default */.Z, {
    name: "HelperText",
    slot: "Icon"
})(function(param) {
    var theme = param.theme;
    return {
        flexShrink: 0,
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 12,
        height: 12,
        marginRight: theme.spacing(0.5),
        backgroundColor: theme.palette.error.main,
        borderRadius: 50
    };
});
var HelperText = function(param) {
    var error = param.error, _size = param.size, size = _size === void 0 ? 15 : _size, sx = param.sx;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        component: "span",
        direction: "row",
        alignItems: "center",
        sx: (0,_object_spread/* default */.Z)({
            color: theme/* default.palette.error.main */.Z.palette.error.main
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelperTextIcon, {
                component: "span",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                    name: "CloseS",
                    sx: {
                        fontSize: 12,
                        path: {
                            fill: function(theme) {
                                return theme.palette.common.white;
                            }
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    fontSize: size
                },
                children: error
            })
        ]
    });
};
/* harmony default export */ var HelperText_HelperText = (HelperText);

;// CONCATENATED MODULE: ./src/components/ui/HelperText/index.tsx
/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */ 


/***/ })

}]);